module.exports = __webpack_public_path__ + "img/t2.d78f82b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/t2.png
// module id = H9Ms
// module chunks = 1